import Vue from 'vue';
import Component, { createDecorator } from 'vue-class-component';
import isNumber from '@/api/isNumber';
import checkItemCount from '@/api/checkItemCount';
import { Product, UpdateProductCountEvent } from '@/api/product';
import { Prop, Watch } from 'vue-property-decorator';
import autoSelect from '@/api/autoSelect';

@Component({
})
export default class BasketElementAbstract extends Vue {
    @Prop() product!: Product
    @Prop({type: Number}) ind!: number
    @Prop({default: false}) showAvailability!: boolean
    @Prop({default: false}) showCheckbox!: boolean
    count = +this.product.quantity
    get quantity() {
        return +this.product.quantity
    }
    get cost() {
        return (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(+this.product.Учетная);
    }
    @Watch('quantity') onQuantityChange(val: number) {
        this.count = val
    }
    updateCount(count: number) {
        let oldVal = this.count;
        this.count = count;
        this.$nextTick(() => {
            this.count = checkItemCount(count, oldVal)
            let upc: UpdateProductCountEvent = {
                vCode: this.product.Артикул,
                count: this.count
            }
            this.$store.dispatch('updateProductCount', upc)
        })
    }
    numberFilter(e: KeyboardEvent, count: number) {
        if (!isNumber(e.key)) e.preventDefault();
    }
    deleteProduct() {
        this.$store.dispatch('deleteProductFromBasket', this.product.Артикул)
    }
    toggleSelected() {
        this.$store.dispatch('toggleProductSelected', this.product.Артикул)
    }
    showImage() {
        this.$store.commit('image:show', this.product.Фото)
    }
    autoSelect = autoSelect
}